// Calculate day number of hike based on post time and start date in PDT
export const getHikeDay = (postTime) => {
  // Get start date from environment variable or fallback to a default
  const startDateStr = '2025-04-28';
  
  // Create dates in Pacific Time
  const options = { timeZone: 'America/Los_Angeles' };
  
  // Convert start date to PDT
  const startDate = new Date(startDateStr);
  
  // Convert post date to PDT
  const postDate = new Date(postTime);
  
  // Use date strings in PDT to get actual day calculation
  const startDatePDT = new Date(startDate.toLocaleString('en-US', options));
  const postDatePDT = new Date(postDate.toLocaleString('en-US', options));
  
  // Calculate difference in days
  const diffTime = postDatePDT - startDatePDT;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
}; 